import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, Select, } from '@dixa/lib-shared-habla';
// eslint-disable-next-line dixa/no-cross-reference-imports
import { useHookFormFieldWrapper, } from 'utils/hookForm';
export const HookFormSimpleSelect = (props) => {
    const { controller, controllerProps, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const handleClear = () => controller.field.onChange(undefined);
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(Select, Object.assign({ multiple: false }, props.componentProps, controller.field, { id: controllerProps.name, selectedItems: [controller.field.value], disabled: fieldWrapperProps.disabled, onChange: controller.field.onChange, onClear: handleClear, onSelect: controller.field.onChange })) })));
};
